function TermsOfServicePage() {
  return (
    <section id="terms-of-service" className="page-section section-odd legal">
      <div className="section-inner">
        <h2>Terms of Service</h2>
        <h3>1. AGREEMENT TO TERMS</h3>
        <p>
          These Terms of Service (&quot;Terms&quot;) constitute a legally binding agreement between you and VEKAC
          SUPPLY LLC (&quot;Company,&quot; &quot;we,&quot; &quot;us,&quot; or &quot;our&quot;) concerning your access to and use of this Site.
        </p>

        <h3>2. SERVICES</h3>
        <p>
          VEKAC SUPPLY LLC is a consulting company. We help organizations optimize their supply chain,
          procurement, logistics, warehousing, and operational processes to improve efficiency, reduce costs,
          and drive sustainable growth.
        </p>

        <h3>3. INTELLECTUAL PROPERTY RIGHTS</h3>
        <p>
          Unless otherwise indicated, the Site and all content and marks are our proprietary property or
          licensed to us, protected by applicable intellectual property laws.
        </p>

        <h3>4. USER REPRESENTATIONS</h3>
        <ol>
          <li>You have the legal capacity to agree to these Terms.</li>
          <li>You are at least 18 years of age.</li>
          <li>You will not access the Site through automated or non-human means.</li>
          <li>You will not use the Site for any illegal or unauthorized purpose.</li>
          <li>Your use of the Site will not violate any applicable law or regulation.</li>
        </ol>

        <h3>5. PROHIBITED ACTIVITIES</h3>
        <ol>
          <li>Systematically retrieve content to create a collection, compilation, database, or directory.</li>
          <li>Trick, defraud, or mislead us and other users.</li>
          <li>Circumvent or interfere with security-related features.</li>
          <li>Use site information to harass, abuse, or harm another person.</li>
          <li>Make improper use of our support services.</li>
          <li>Use the Site in a manner inconsistent with applicable laws or regulations.</li>
          <li>Engage in unauthorized framing of or linking to the Site.</li>
          <li>Upload or transmit harmful material like viruses or Trojan horses.</li>
          <li>Attempt unauthorized access to any part of the Site or related systems.</li>
        </ol>

        <h3>6. PURCHASES AND PAYMENT</h3>
        <p>
          We accept various payment methods for purchases made through the Site. You agree to provide
          current, complete, and accurate purchase and account information.
        </p>

        <h3>7. SMS COMMUNICATIONS</h3>
        <p>
          By providing your mobile number and consent, you agree to receive recurring SMS messages, including
          automated marketing messages, from or on behalf of VEKAC SUPPLY LLC.
        </p>

        <h3>8. RETURNS AND REFUNDS</h3>
        <ul>
          <li>All returns must be requested within 30 days of receipt.</li>
          <li>Products must be in original packaging and in resalable condition.</li>
          <li>Custom orders are non-refundable.</li>
          <li>Shipping costs are non-refundable.</li>
          <li>A restocking fee of 15% may apply to certain returns.</li>
        </ul>

        <h3>9. DISCLAIMER</h3>
        <p>
          THE SITE IS PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. TO THE FULLEST EXTENT PERMITTED BY LAW,
          WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED.
        </p>

        <h3>10. LIMITATION OF LIABILITY</h3>
        <p>
          IN NO EVENT WILL WE BE LIABLE FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL,
          SPECIAL, OR PUNITIVE DAMAGES ARISING FROM YOUR USE OF THE SITE.
        </p>

        <h3>11. INDEMNIFICATION</h3>
        <p>
          You agree to defend, indemnify, and hold us harmless from claims, damages, liabilities, and
          expenses arising from your use of the Site or breach of these Terms.
        </p>

        <h3>12. TERM AND TERMINATION</h3>
        <p>
          These Terms remain in effect while you use the Site. We reserve the right to deny access to the
          Site for any reason, including violations of these Terms or applicable law.
        </p>

        <h3>13. MODIFICATIONS AND INTERRUPTIONS</h3>
        <p>We reserve the right to change, modify, or remove Site content at any time without prior notice.</p>

        <h3>14. GOVERNING LAW</h3>
        <p>
          These Terms are governed by the laws of the State of Florida, and the courts of Orlando-Dade County
          have exclusive jurisdiction over disputes.
        </p>

        <h3>15. CORRECTIONS</h3>
        <p>
          Information on the Site may contain typographical errors, inaccuracies, or omissions. We reserve the
          right to correct these issues at any time without prior notice.
        </p>

        <h3>16. CONTACT US</h3>
        <p>
          For any questions about these Terms, contact:
          <br />
          VEKAC SUPPLY LLC
          <br />
          7345 W SAND LAKE RD STE 210 OFFICE 4975 ORLANDO, FLORIDA
          <br />
          Email: <a href="mailto:legal@vekac-supply.com">legal@vekac-supply.com</a>
        </p>
      </div>
    </section>
  );
}

export default TermsOfServicePage;
